import { mapChannelToParamType } from "./channelParamMap";

// Normalizes a raw WebSocket frame — either the new multi-channel format
// or the legacy single-param format (both per
// TELEMETRY_PAYLOAD_SPECIFICATION-2.md §3/§5) — into a flat list of
// samples, one per channel, ready to dispatch via mergeLiveKeyarSample.
// Frames with no usable patient_id (undefined/null) are skipped; patient_id
// 0 (emergency/unassigned monitoring, §3.2) is passed through as-is.
// session_uuid is carried through on every sample so the Redux layer can
// key/re-key unassigned sessions by it (see keyarData.js).
export function normalizeKeyarFrame(frame) {
    if (!frame || frame.patient_id === undefined || frame.patient_id === null) {
        return [];
    }

    const { patient_id, session_uuid } = frame;

    if (frame.channels && typeof frame.channels === "object") {
        return Object.entries(frame.channels).map(([channelName, channel]) => ({
            patient_id,
            session_uuid,
            param_type: mapChannelToParamType(channelName),
            data_points: channel.data_points || {},
            meta_data: channel.meta_data,
            serial_number: channel.meta_data?.device_serial,
        }));
    }

    if (frame.param_type) {
        return [
            {
                patient_id,
                session_uuid,
                param_type: mapChannelToParamType(frame.param_type),
                data_points: frame.data_points || {},
                meta_data: frame.meta_data,
                serial_number: frame.meta_data?.device_serial,
            },
        ];
    }

    return [];
}
